"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.protoDurationToMs = exports.nativeToProtoTimestamp = exports.protoTimestampToNative = void 0;
/**
 * Converts a protobuf timestamp to a native Javascript representation.
 *
 * Allows Date as argument for compatibility with generated types (Date) vs actual gRPC request (google.protobuf.Timestamp).
 */
function protoTimestampToNative(stamp) {
    if (stamp instanceof Date) {
        return stamp;
    }
    if (stamp?.seconds == undefined) {
        return null;
    }
    const seconds = stamp.seconds.low
        ? stamp.seconds.low
        : stamp.seconds;
    const nanos = stamp.nanos ?? 0;
    return new Date(seconds * 1000 + nanos / 1000000);
}
exports.protoTimestampToNative = protoTimestampToNative;
/**
 * Converts a native javascript date object to a protobuf date.
 *
 * @param date The date to convert.
 * @returns The protobuf structured date.
 */
function nativeToProtoTimestamp(date) {
    const seconds = Math.floor(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
exports.nativeToProtoTimestamp = nativeToProtoTimestamp;
/*
 * Converts a protobuf duration to milliseconds.
 *
 * @param duration The protobuf duration to convert.
 * @returns The duration in milliseconds, or null if the input is undefined.
 */
function protoDurationToMs(duration) {
    if (!duration) {
        return null;
    }
    const seconds = duration.seconds || 0;
    const nanos = duration.nanos || 0;
    // Convert seconds to ms, and nanos to ms, then sum them
    return seconds * 1000 + Math.round(nanos / 1e6);
}
exports.protoDurationToMs = protoDurationToMs;
